export default {
    'MANAGERS.ADD.FORM.TITLE': 'Add a manager',
    'MANAGERS.EDIT.FORM.TITLE': 'Edit a manager',
    'MANAGERS.DELETE.FORM.TITLE': 'DELETE THIS MANAGER',
    'MANAGERS.DELETE.FORM.CONFIRM.TITLE': 'Delete a manager',
    'MANAGERS.DELETE.FORM.CONFIRM.SUB': 'Are you sure you want to delete this manager ?',
};
